import FormulaireInscription from "../components/FormulaireInscription"

const Inscription = () => {
    
    return <FormulaireInscription />
  };
  
  export default Inscription;